import { render, staticRenderFns } from "./RepositoriosPage.vue?vue&type=template&id=aa782880&scoped=true"
import script from "./RepositoriosPage.vue?vue&type=script&lang=js"
export * from "./RepositoriosPage.vue?vue&type=script&lang=js"
import style0 from "./RepositoriosPage.vue?vue&type=style&index=0&id=aa782880&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa782880",
  null
  
)

export default component.exports